import { useMutation } from 'react-query';
import { wgApi } from '../../../../app/src/features/api/wgApi';

interface SendSimulationEmailParams {
  partyId: string;
  sessionId: string;
  payload: {
    action_url: string;
    emails: string[];
  };
}

export const postYellowhiveSendSimulationEmail = async ({
  partyId,
  sessionId,
  payload,
}: SendSimulationEmailParams) => {
  const path = `/v1/api/parties/${partyId}/simulations/${sessionId}/email-inquiries`;
  const { data, isError } = await wgApi.post(path, payload);
  if (isError) throw new Error();
  return data;
};

export const usePostYellowhiveSendSimulationEmail = () => {
  return useMutation(postYellowhiveSendSimulationEmail);
};
